import React from 'react';
import VersionToggle from './VersionToggle';

/**
 * Footer component that displays copyright information
 */
const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="footer">
      <p>&copy; {currentYear} Old School News Aggregator. All rights reserved.</p>
      <VersionToggle />
    </footer>
  );
};

export default Footer; 